import {FC, useState} from 'react'
import {useAppDispatch, useAppSelector} from '../../../../hooks/redux'
import {setQuery} from '../../../cdr/slices/cdrFilterSlice'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import {shallowEqual} from 'react-redux'
import moment from 'moment'
import {usersAPI} from '../../../../services/UsersService'
import clsx from 'clsx'

type Props = {
  data: number
  date?: string
}

const CSRItemOutbound: FC<Props> = ({data, date}) => {
  const {appId} = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()
  const queryCsr = useAppSelector((state) => state.csrFilter)
  const queryCdr = useAppSelector((state) => state.cdrFilter.query, shallowEqual)
  const [linkCDR] = useState<string>(location.pathname.includes('/management') ? '/management/cdr' : '/cdr')

  function getDateRange(tz: string, group_by: string): string {
    if (group_by === 'day') {
      const start = moment.tz(date, tz).startOf('day').utc()
      const end = moment.tz(date, tz).endOf('day').utc()
      return `${start.format('YYYY-MM-DDTHH:mm:ss')},${end.format('YYYY-MM-DDTHH:mm:ss')}`
    }

    if (queryCsr.group_by === 'week') {
      const start = moment.tz(date, tz).startOf('day').utc()
      const end = moment.tz(date, tz).endOf('week').utc()
      return `${start.format('YYYY-MM-DDTHH:mm:ss')},${end.format('YYYY-MM-DDTHH:mm:ss')}`
    }

    if (queryCsr.group_by === 'month') {
      const start = moment.tz(date, tz).startOf('day').utc()
      const end = moment.tz(date, tz).endOf('month').utc()
      return `${start.format('YYYY-MM-DDTHH:mm:ss')},${end.format('YYYY-MM-DDTHH:mm:ss')}`
    }

    return ''
  }

  const handlerToCdrMissed = () => {
    dispatch(
      setQuery({
        period: getDateRange(currentUser?.time_zone! || 'Europe/Minsk', queryCsr.group_by),
        limit: queryCdr?.limit,
        offset: 0,
        direction: 'OUTBOUND',
      })
    )
    navigate(`${linkCDR}/${appId}/`)
  }

  return (
    <div className='d-flex align-items-center'>
      <div
        className={clsx('d-flex justify-content-start flex-column me-3 text-gray-800', {'cursor-pointer': data > 0})}
        onClick={handlerToCdrMissed}
      >
        {data > 0 ? (
          <OverlayTrigger
            delay={{show: 50, hide: 50}}
            overlay={
              <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                Перейти к <span className='text-success'>исходящим</span> в журнале звонков
              </Tooltip>
            }
          >
            <span className={clsx('text-gray-900 small', {'text-hover-primary': data > 0})}>{data}</span>
          </OverlayTrigger>
        ) : (
          <span className='text-gray-900 small'>{data}</span>
        )}
      </div>
    </div>
  )
}

export {CSRItemOutbound}
